<template>
    <div class="overlay" :class="{active: this.$root.menu_active}">

        <div class="bg"></div>

        <div class="container" @mouseleave="removeActive()">
            <div class="row">
                <div class="col-12 col-md-6 pr-0 top-level" :class="hideTopLevel ? 'hide-top-level' : ''">
                    <nav id="main-nav" v-if="menu">
                        <ul>
                            <li v-for="(item, i) in menu" :key="item.ID">
                                <a v-if="item.children.length == 0" :href="item.url" v-html="item.title" @mouseover="setSubMenu(item, i)" class="d-none d-md-block has-line" :class="[activeTopLevelIndex == null ? 'none-active' : '', activeTopLevelIndex == i ? 'active-menu' : 'non-active-menu']"></a>
                                <p v-else :href="item.url" v-html="item.title" @mouseover="setSubMenu(item, i)" class="d-none d-md-block has-line" :class="[activeTopLevelIndex == null ? 'none-active' : '', activeTopLevelIndex == i ? 'active-menu' : 'non-active-menu']"></p>
                                <span v-if="Object.values(item.children) && Object.values(item.children).length > 0" class="line d-none d-md-block" :class="activeTopLevelIndex == i ? 'show' : ''"></span>
                                <a v-if="item.children.length == 0" :href="item.url" v-html="item.title" class="d-block d-md-none"></a>
                                <p v-else :href="item.url" v-html="item.title" @touch="openSubMenuPage(item)" @click="openSubMenuPage(item)" class="d-block d-md-none"></p>
                            </li>
                        </ul>
                    </nav>
                    <div class="d-block d-md-none pb-5">
                        <div class="email"><a :href="'mailto:' + options.email">{{options.email}}</a></div>
                        <div class="phone"><a :href="'tel:' + options.phone">{{options.phone}}</a></div>
                        <ul class="social-media">
                            <li v-for="(social, i) in social_media" :key="'social-' + i"><a rel="noopener" :href="social.link" target="_blank" v-html="social.icon"></a></li>
                        </ul>
                    </div>
                </div>

                <!-- SUBMENU MOBILE -->
                <div class="col-12 col-md-6 col-lg-4 align-self-center d-block d-md-none mobile-submenu" :class="showSubMenu ? 'show-sub-menu' : ''">
                    <p class="back-btn" @click="goBack()"><span class="back-btn-icon"></span> Go back</p>
                    <ul class="submenu" v-if="currentSubMenu">
                        <li v-for="subitem in currentSubMenu" :key="subitem.ID">
                            <a :href="subitem.url" v-html="subitem.title"></a>
                        </li>
                    </ul>
                    <div class="pb-5">
                        <div class="email"><a :href="'mailto:' + options.email">{{options.email}}</a></div>
                        <div class="phone"><a :href="'tel:' + options.phone">{{options.phone}}</a></div>
                        <ul class="social-media">
                            <li v-for="(social, i) in social_media" :key="'social-' + i"><a rel="noopener" :href="social.link" target="_blank" v-html="social.icon"></a></li>
                        </ul>
                    </div>
                </div>

                <!-- SUBMENU DESKTOP -->
                <div class="col-12 col-md-6 col-lg-4 d-none d-md-block pt-4 pl-0 submenu-wrapper" :class="hideSubmenu ? 'hide-submenu' : 'show-submenu'">
                    <ul class="submenu" v-if="currentSubMenu">
                        <li v-for="subitem in currentSubMenu" :key="subitem.ID">
                            <a :href="subitem.url" v-html="subitem.title"></a>
                        </li>
                    </ul>
                </div>

                <div class="col-12 col-lg-2 align-self-center line-left d-none d-md-block" style="z-index: 10;">
                    <div class="email"><a :href="'mailto:' + options.email">{{options.email}}</a></div>
                    <div class="phone"><a :href="'tel:' + options.phone">{{options.phone}}</a></div>
                    <ul class="social-media">
                        <li v-for="(social, i) in social_media" :key="'social-' + i"><a rel="noopener" :href="social.link" target="_blank" v-html="social.icon"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            menu: {
                type: Array,
                default() {
                    return []
                }
            },
            options: {
                type: Object,
                default() {
                    return {}
                }
            },
            social_media: {
                type: Array,
                default() {
                    return []
                }
            },
            menu_is_active: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                currentSubMenu: [],
                hideTopLevel: false,
                showSubMenu: false,
                activeTopLevelIndex: null,
                hideSubmenu: true
            }
        },
        mounted() {
            // console.log(this.menu);
            // console.log(this.menu_is_active);
            // console.log(this.social_media);
            // console.log('pll_strings: ', pll_strings);
        },
        watch: {
            menu_is_active: {
                handler: function() {
                    if(!this.menu_is_active) {
                        setTimeout(() => {
                            this.hideTopLevel = false;
                            this.showSubMenu = false;
                            this.currentSubMenu = [];
                        }, 500);
                    }
                }
            }
        },
        methods: {
            setSubMenu(item, i) {
                this.activeTopLevelIndex = i;
                setTimeout(() => {
                    this.currentSubMenu = item.children;
                }, 250);

                this.hideSubmenu = true;

                setTimeout(() => {
                    this.hideSubmenu = false;
                }, 500);
            },
            goBack() {
                this.hideTopLevel = false;
                this.showSubMenu = false;
                // this.currentSubMenu = [];
            },
            removeActive() {
                if(window.innerWidth > 768) {
                    this.activeTopLevelIndex = null;
                    this.currentSubMenu = [];
                }
            },
            openSubMenuPage(item, i) {
                this.activeTopLevelIndex = i;
                this.hideTopLevel = true;
                this.showSubMenu = true;
                this.currentSubMenu = [];
                console.log(item);
                // this.currentSubMenu.push(item);
                Object.values(item.children).forEach(child => {
                    this.currentSubMenu.push(child);
                });
                console.log("open submenu page");
            }
        },
    }
</script>

<style lang="scss" scoped>
    .pl-0 {
        padding-left: 0!important;
    }
    .pr-0 {
        padding-right: 0!important;
    }
    .overlay {
        position: fixed;
        top: 0px; left: 0px; width: 100%; height: 100%;
        background: $red;
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s ease, visibility 0s .5s ease;
        display: flex;
        flex-flow: wrap row;
        align-items: center;
        overflow-y: scroll;
        overflow-x: hidden;

        .container {
            max-width: 1200px;

            @media screen and (min-width: 769px) {
                .row {
                    padding: 120px 0 80px;
                }
            }
        }

        .row {
            z-index: 100;
        }

        ul.social-media {
            margin-top: 1rem;
            li {
                a {
                    color: $white!important;

                    &:hover {
                    color: $white!important;
                    }
                }
            }
        }

        .bg {
            background: #BF0E3B;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(50vh - 200px);
            z-index: 1;

            &:after {
                content: '';
                position: absolute;
                bottom: -12.9vw;
                width: 100%;
                height: 13vw;
                background-image: url("data:image/svg+xml,%3Csvg width='2345' height='269' viewBox='0 0 2345 269' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M1175.98 268.824C726.396 268.824 299.958 180.683 3.49952 31.9998C1.01074 30.8242 0.763294 30.8098 0.0107422 30.6019L0.0108851 0.824219L2344.01 0.824424V30.6021C2344.01 31.3242 2344 31.5 2344.01 32.0001C2047.55 183.354 1625.57 268.824 1175.98 268.824Z' fill='%23BF0E3B'/%3E %3C/svg%3E ");
                background-size: cover;
                background-position: center;
            }
        }

        .top-level {
            position: absolute;
            top: 150px;
            transition: 0.6s all;
            z-index: 10000;

            @media screen and (min-width: 769px) {
                position: relative;
                top: 0;
            }

            &.hide-top-level {
                transform: translateX(-100%);
            }
        }

        &.active {
            opacity: 1;
            visibility: visible;
            transition: opacity .5s ease;
        }

        #main-nav {
            position: relative;
            z-index: 2;

            ul {
                list-style: none;
                padding: 0px;
                margin: 0px;
                transition: opacity .5s ease;

                li a, li p {
                    white-space: nowrap;
                    text-decoration: none!important;
                    &.non-active-menu {
                        opacity: 0.3;
                    }

                    &.active-menu {
                        opacity: 1;
                    }

                    &.none-active {
                        opacity: 1!important;
                    }
                }

                li {
                    margin: 2rem 0;
                    display: flex;

                    .line {
                        height: 2px;
                        background: white;
                        width: 0;
                        align-self: flex-end;
                        margin: 0 2rem;
                        margin-bottom: 40px;
                        transition: 1.5s all;
                        opacity: 0.3;

                        &.show {
                            opacity: 1;
                            width: 100%;
                        }
                    }

                    a, p {
                        font-family: 'Poppins', sans-serif;
                        transition: opacity .5s ease;
                        color: $white;
                        font-size: 3rem;
                        line-height: 1.2;
                        cursor: pointer;

                        @media screen and (min-width: 769px) {
                            font-size: 3rem;
                        }


                        @media screen and (min-width: 1100px) {
                            font-size: 4rem;
                        }

                        &:hover {
                            opacity: 1;
                            color: white;
                        }

                    }
                }
            }
        }

        ul.submenu {
            list-style: none;
            position: relative;
            z-index: 2;
            padding: 0;
            margin: 0;

            @media screen and (min-width: 769px) {
                padding-left: 1rem;
            }

            li {
                margin: 1rem 0;

                a, p {
                    font-family: 'Poppins', sans-serif;
                    color: $white;
                    font-size: 1.2rem;
                    padding-bottom: .3rem;
                    border-bottom: 1px solid transparent;
                    transition: $ts;
                    text-decoration: none!important;

                    &:hover {
                        border-bottom: 1px solid $white;
                    }
                }
            }
        }
    }

    .mobile-submenu {
        position: absolute;
        top: 150px;
        left: 0;
        transition: 0.6s all;
        z-index: 10000;
        transform: translateX(100%);

        &.show-sub-menu {
            transform: translateX(0);
        }

        .back-btn {
            color: $white;
            cursor: pointer;
            margin-bottom: 2rem;
            .back-btn-icon {
                width: 25px;
                height: 25px;
                display: inline-block;
                border-radius: 100px;
                border: 1px solid $white;
                margin-bottom: -6px;
                margin-right: 5px;
            }
        }
    }

    .email, .phone {
        a {
            font-size: 14px;
            color: $white;
            margin: .5rem 0;
            position: relative;
            z-index: 2;
        }
    }

    .email {
        margin-top: 4rem;
    }

    .submenu-wrapper {
        transition: 0.3s all;
        z-index: 10000000;

        &.hide-submenu {
            opacity: 0;
        }

        &.show-submenu {
            opacity: 1;
        }
    }
</style>
